module.exports = __webpack_public_path__ + "static/media/comment-slash.f6e23c4e.svg";